if (!customElements.get('byte-mobile-nav')) {
  class ByteMobileNav extends HTMLElement {
    constructor() {
      super();

      this.boundHandleClick = this.handleClick.bind(this);
      this.boundHandleCartCountChange = this.handleCartCountChange.bind(this);
      this.boundHandleMenuToggle = this.handleMenuToggle.bind(this);
      this.cartCountObserver = null;
    }

    connectedCallback() {
      this.#cacheElements();
      this.#bindEvents();
      this.#syncCartCount();
    }

    disconnectedCallback() {
      this.#unbindEvents();
    }

    handleClick(event) {
      const actionTrigger = event.target.closest('[data-mobile-nav-action]');
      if (!actionTrigger) return;

      const mobileNavAction = actionTrigger.dataset.mobileNavAction;

      if (mobileNavAction === 'menu') {
        event.preventDefault();
        this.toggleMenu(actionTrigger);
      }
    }

    handleCartCountChange() {
      this.#syncCartCount();
    }

    handleMenuToggle() {
      this.#syncMenuState();
    }

    toggleMenu() {
      if (!this.menuSummary) return;

      this.menuSummary.click();
    }

    #cacheElements() {
      this.menuTrigger = this.querySelector('[data-mobile-nav-action="menu"]');
      this.cartCount = this.querySelector('[data-mobile-nav-cart-count]');
      this.headerCartIcon = document.querySelector('#cart-icon-bubble');
      this.headerDrawer = document.querySelector('header-drawer');
      this.menuDetails = this.headerDrawer?.querySelector('details');
      this.menuSummary = this.menuDetails?.querySelector('summary');
    }

    #bindEvents() {
      this.addEventListener('click', this.boundHandleClick);

      if (this.menuDetails) {
        this.menuDetails.addEventListener('toggle', this.boundHandleMenuToggle);
      }

      if (!this.headerCartIcon || !this.cartCount) return;

      this.cartCountObserver = new MutationObserver(this.boundHandleCartCountChange);
      this.cartCountObserver.observe(this.headerCartIcon, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    #unbindEvents() {
      this.removeEventListener('click', this.boundHandleClick);

      if (this.menuDetails) {
        this.menuDetails.removeEventListener('toggle', this.boundHandleMenuToggle);
      }

      if (this.cartCountObserver) {
        this.cartCountObserver.disconnect();
        this.cartCountObserver = null;
      }
    }

    #syncMenuState() {
      if (!this.menuTrigger || !this.menuDetails) return;

      const isMenuOpen = this.menuDetails.hasAttribute('open');
      this.menuTrigger.setAttribute('aria-expanded', String(isMenuOpen));
      this.menuTrigger.classList.toggle('is-active', isMenuOpen);
    }

    #syncCartCount() {
      if (!this.cartCount || !this.headerCartIcon) return;

      const headerCount = this.headerCartIcon.querySelector('.cart-count-bubble [aria-hidden="true"]');
      const cartCountValue = headerCount ? headerCount.textContent.trim() : '';

      this.cartCount.textContent = cartCountValue;
    }
  }

  customElements.define('byte-mobile-nav', ByteMobileNav);
}
